import {charcoal} from '../sass/base/_exports.sass';

export const ThreeQuarterFilledEllipseIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1} = props;

  // default dimensions
  const width = 20;
  const height = 21;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox={`0 0 ${width} ${height}`}
      style={style}
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 10.9206C20 16.4435 15.5228 20.9206 10 20.9206C4.47715 20.9206 0 16.4435 0 10.9206C0 5.39776 4.47715 0.920609 10 0.920609C15.5228 0.920609 20 5.39776 20 10.9206ZM4 10.9206C4 14.2343 6.68629 16.9206 10 16.9206C13.3137 16.9206 16 14.2343 16 10.9206C16 7.6069 13.3137 4.92061 10 4.92061C6.68629 4.92061 4 7.6069 4 10.9206Z"
        fill="#B9BCBF"
      />
      <path
        d="M0 10.9206C-1.72906e-07 12.8984 0.586489 14.8318 1.6853 16.4763C2.78412 18.1208 4.3459 19.4025 6.17316 20.1594C8.00043 20.9163 10.0111 21.1143 11.9509 20.7285C13.8907 20.3426 15.6725 19.3902 17.0711 17.9917C18.4696 16.5932 19.422 14.8113 19.8079 12.8715C20.1937 10.9317 19.9957 8.92104 19.2388 7.09377C18.4819 5.26651 17.2002 3.70473 15.5557 2.60591C13.9112 1.5071 11.9778 0.920609 10 0.920609L10 4.92061C11.1867 4.92061 12.3467 5.2725 13.3334 5.93179C14.3201 6.59108 15.0892 7.52815 15.5433 8.62451C15.9974 9.72087 16.1162 10.9273 15.8847 12.0912C15.6532 13.255 15.0818 14.3241 14.2426 15.1632C13.4035 16.0024 12.3344 16.5738 11.1705 16.8053C10.0067 17.0368 8.80026 16.918 7.7039 16.4639C6.60754 16.0098 5.67047 15.2407 5.01118 14.254C4.35189 13.2673 4 12.1073 4 10.9206H0Z"
        fill={color}
      />
    </svg>
  );
};
